// Filters
Vue.filter('strLimit', function(value = 200) {
    if (value.length > value) {
        return value.substring(0, value) + '...'
    } else {
        return value
    }
});

Vue.filter('toCurrency', function(value) {

    let formatter = new Intl.NumberFormat('en-IN', {
        style                 : 'currency',
        currency              : 'GBP',
        minimumFractionDigits : 2
    });
    return formatter.format(value).replace(/\s/g, '');
});

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MMM/YYYY')
    }
});

Vue.filter('formatExpiry', function(value) {
    if (value) {
        return moment(String(value)).format('MM/YYYY')
    }
});

Vue.filter('capitalize', function(value) {
    if (!value) {
        return '';
    }
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1)
});

Vue.filter('number', function(value, digits = 2) {
    const amt = Number(value);
    return amt && amt.toLocaleString(undefined, {maximumFractionDigits : digits}) || '0';
});
Vue.filter('uom', function(value) {
    return value.replace(/([^0-9]|^)1X/, '$1').replace('EACH', 'Pack');
});

Vue.mixin({
    methods : {
        isMobile           : function() {
            return !!(navigator.userAgent.match(/Android/i)
                || navigator.userAgent.match(/webOS/i)
                || navigator.userAgent.match(/iPhone/i)
                || navigator.userAgent.match(/iPod/i)
                || navigator.userAgent.match(/BlackBerry/i)
                || navigator.userAgent.match(/Windows Phone/i));
        },
        hasWebp            : function() {
            return document.documentElement.classList.contains('webp');
        },
        currentSite        : function() {
            return window.Site;
        },
        laravel            : function() {
            return window.Laravel;
        },
        user               : function() {
            return window.User;
        },
        isObject           : function(obj) {
            // Check it's an object
            if (typeof obj !== 'object') {
                return false;
            }

            // Check it's not also empty
            if (Object.getOwnPropertyNames(obj).length < 2) {
                return false;
            }

            return true;
        },
        titleCase          : function(str) {
            return str.toLowerCase().split(' ').map(function(word) {
                return word.replace(word[0], word[0].toUpperCase());
            }).join(' ');
        },
        addToCartAnalytics : function(productImpression, currencyCode, actionField = null, itemQuantityImpression = 1) {
            let cartAnalyticsValues = {
                'event'         : 'add_to_cart',
                'eventCategory' : 'ecommerce',
                'eventAction'   : 'add_to_cart',
                'ecommerce'     : {
                    'currencyCode' : currencyCode,
                    'add'          : {
                        'products' : productImpression
                    },
                }
            };

            delete cartAnalyticsValues.ecommerce.add.products[0].list;

            cartAnalyticsValues.ecommerce.add.products[0].quantity = itemQuantityImpression

            if (actionField != null) {
                cartAnalyticsValues.ecommerce.add.actionField = {'list' : actionField};
            }

            window.dataLayer.push(cartAnalyticsValues)
        },
        getCtaMenuValues : function(eventCategory, eventAction, eventLabel) {
            window.dataLayer.push({
                'event' : 'cta',
                'eventCategory' : eventCategory,
                'eventAction' : eventAction,
                'eventLabel' : eventLabel,
            });
        }
    }
})


Vue.prototype.$eventHub = new Vue(); // Global event bus

import store from './store.js';

if (process.env.MIX_ENV_MODE === 'production') {
    Vue.config.devtools = false;
    Vue.config.debug    = false;
    Vue.config.silent   = true;
}

// At the bottom to fire after all elements have loaded
const app = new Vue({
    el    : '#app',
    store : new Vuex.Store(store)
});
